const bitsToMegaBytes = (bitsize: number, ceilResult = false) => {
    const size = bitsize / (1024 * 1024);

    return ceilResult ? Math.ceil(size) : size;
};

export default bitsToMegaBytes;
